import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i7.4
import React from 'react';
import IconWrap from '../../IconWrap';
const FullWidthImage = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18 19a1 1 0 010 2H6a1 1 0 010-2zm2-16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1z"
    })));
};
FullWidthImage.displayName = 'FullWidthImage';
export default FullWidthImage;
